import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';
import {
  registerSuccess,
  registerError,
  loginSuccess,
  loginError,
  logoutSuccess,
  logoutError,
  getCurrentUserSuccess,
  getCurrentUserError,
} from './auth-actions';
import { addTransactionSuccess } from '../transactions/transactions-actions';

const initialUserState = {
  name: null,
  email: null,
};
const userReducer = createReducer(initialUserState, {
  [registerSuccess]: (_, { payload }) => payload.data,
  [loginSuccess]: (_, { payload }) => payload.data,
  [logoutSuccess]: () => initialUserState,
  [getCurrentUserSuccess]: (_, { payload: { data } }) => data,
  [addTransactionSuccess]: (state, { payload: { data } }) => ({
    ...state,
    balance: data.balance,
  }),
});

const tokenReducer = createReducer(null, {
  [loginSuccess]: (_, { payload }) => payload.data.token,
  [logoutSuccess]: () => null,
});

const errorReducer = createReducer(null, {
  [registerSuccess]: (_, { payload }) => null,
  [loginSuccess]: (_, { payload }) => null,
  [registerError]: (_, { payload }) => payload,
  [loginError]: (_, { payload }) => payload,
  [logoutError]: (_, { payload }) => payload,
  [getCurrentUserError]: (_, { payload }) => payload,
});

const isAuthenticatedReducer = createReducer(false, {
  [registerSuccess]: () => false,
  [loginSuccess]: () => true,
  [getCurrentUserSuccess]: () => true,
  [registerError]: () => false,
  [loginError]: () => false,
  [getCurrentUserError]: () => false,
  [logoutSuccess]: () => false,
});
const authReducer = combineReducers({
  user: userReducer,
  isAuthenticated: isAuthenticatedReducer,
  token: tokenReducer,
  error: errorReducer,
});

export default authReducer;
